exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] ._2jrXwTj98XmnEsW4YnXp3N{margin:0;border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\";background-color:\"[theme:white, default:#ffffff]\"}html[dir=ltr] ._2jrXwTj98XmnEsW4YnXp3N{padding:9px 12px 6px 16px}html[dir=rtl] ._2jrXwTj98XmnEsW4YnXp3N{padding:9px 16px 6px 12px}", ""]);
// Exports
exports.locals = {
	"notesHeader": "_2jrXwTj98XmnEsW4YnXp3N"
};